<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="invoiceApplicationTypes"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="100px" @keyup.enter.native="loadData(1)">
            <el-form-item label="税收分类编码">
              <el-input v-model.trim="filter.code" placeholder="请输入编码" clearable/>
            </el-form-item>
            <el-form-item label="税收分类名称">
              <el-input v-model.trim="filter.typeName" placeholder="请输入名称" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <invoice-type-code-edit ref="invoiceTypeCodeEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import InvoiceTypeCodeEdit from "./InvoiceTypeCodeEdit.vue";

  export default {
    name: "InvoiceTypeCodeList",
    components: { ViewTable, InvoiceTypeCodeEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(137),
          editAuth: this.$auth(137),
          delAuth: this.$auth(137),
        },
        filter: {
          code: "",
          typeName: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "code",
            width: 150,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.invoiceTypeCodeEdit.open(params.row, true);
                    },
                  },
                },
                params.row.code,
              );
            },
          },
          {
            tooltip: true,
            key: "typeName",
            minWidth: 200,
          },
          {
            tooltip: true,
            key: "note",
            minWidth: 200,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.invoiceTypeCodeEdit.open(row);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "invoiceApplicationTypes", row.pkid)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.loadData();
            }
          });
      },
    },
  };
</script>
